export interface ProfileData {
  id: string;
  fullName: string;
  avatar: string;
  isActive: boolean;
  phone: string;
  email: string;
  alias: string;
  companyName: string;
  companyAddress: {
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
  reportingTo: string;
  isOutOfOffice: boolean;
}

export interface WorkflowDelegation {
  id: string;
  userName: string;
  approvalWorkflow: string;
  fromDate: string;
  toDate: string;
  delegatee: string;
}

export const profileData: ProfileData = {
  id: '1',
  fullName: 'Tom Cook',
  avatar: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg',
  isActive: true,
  phone: '+1 (555) 987-6543',
  email: 'wgc@example.com',
  alias: 'Tom',
  companyName: 'Wilson Garage Corp',
  companyAddress: {
    street: '599 NW BAY BLVD',
    city: 'Seattle',
    state: 'Washington DC',
    zip: '56743',
    country: 'USA'
  },
  reportingTo: 'John Doe',
  isOutOfOffice: false
};

export const initialDelegations: WorkflowDelegation[] = [
  {
    id: '1',
    userName: 'Tony K Stark',
    approvalWorkflow: 'Budget Approval',
    fromDate: '2025-01-15',
    toDate: '2025-01-30',
    delegatee: 'Steve Rogers'
  },
  {
    id: '2',
    userName: 'Tony K Stark',
    approvalWorkflow: 'Expense Approval',
    fromDate: '2025-02-10',
    toDate: '2025-02-20',
    delegatee: 'Natasha Romanoff'
  },
  {
    id: '3',
    userName: 'Tony K Stark',
    approvalWorkflow: 'Leave Approval',
    fromDate: '2025-03-05',
    toDate: '2025-03-15',
    delegatee: 'Bruce Banner'
  }
];
export const approvalWorkflows = [
  { id: 1, text: 'Purchase Order Approval' },
  { id: 2, text: 'Expense Report Approval' },
  { id: 3, text: 'Leave Request Approval' }
];

export const delegates = [
  { id: 1, text: 'Jane Smith' },
  { id: 2, text: 'Michael Johnson' },
  { id: 3, text: 'Sarah Williams' }
];

export const contacts = [
  { id: 1, name: 'USA' },
  { id: 2, name: 'Mexico' },
  { id: 3, name: 'California' }
];

export const influencers = [
  { id: 1, name: 'USA' },
  { id: 2, name: 'Mexico' },
  { id: 3, name: 'California' },
  { id: 4, name: 'Texas' },
  { id: 5, name: 'Warehouse 1' },
  { id: 6, name: 'Warehouse 2' },
  { id: 7, name: 'Warehouse 3' },
  { id: 8, name: 'Warehouse 4' }
];
